import KValidationProvider from "./KValidationProvider";
import { VAutocomplete } from "vuetify/lib";
import {
	getItemsForGroupableSelects,
	sortByKey
} from "kinnect-helpers";

export default {
	name: "KAutocomplete",

	extends: KValidationProvider,

	props: {
		...VAutocomplete.options.props,

		color: {
			default: "link",
			type: String
		},

		groupBy: String,

		itemColor: {
			default: "link",
			type: String
		}
	},

	computed: {
		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VAutocomplete.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		},

		sortedItems() {
			return sortByKey( this.items, this.itemText );
		},

		groupedItems() {
			if ( this.groupBy ) {
				return getItemsForGroupableSelects(
					this.sortedItems,
					this.groupBy
				);
			}

			return this.sortedItems;
		}
	},

	methods: {
		genValidatableField( props ) {
			return <VAutocomplete
				attrs={{
					...this.$attrs,
					...this.propsToPass,
					errorMessages: props.errors,
					items: this.groupedItems
				}}
				on={{ ...this.$listeners }}
				scopedSlots={this.$scopedSlots}
				vModel={this.internalValue}
			>
				{Object.keys( this.$slots ).map( slot =>
					<template slot={slot} key={slot}>{this.$slots[slot]}</template>
				)}
			</VAutocomplete>;
		}
	},

	render() {
		return this.genValidationProvider();
	}
};
